export function findLowerBound(arr: number[], a: number): number | null {
    if (!arr || arr.length === 0) {
        return null;
    }
    const res = arr.findIndex((v) => a < v);
    if (res === 0) {
        return null;
    }
    if (res === -1) {
        return arr[arr.length - 1];
    }
    return arr[res - 1];
}
